import IconCancel from '@pages/Payment/Components/IconCancel'
import { Modal } from 'antd'
import React, { FC } from 'react'
import DownloadQrImage from './DownloadQrImage'
import QrExpiryNotice from './QrExpiryNotice'

interface IProps {
  img?: string
  isModalOpen: boolean
  expiresAtMs?: number
  isSkipSelectBill?: boolean
  setIsModalOpen: (value: boolean) => void
}

const ModalACB: FC<IProps> = ({ isModalOpen, img, setIsModalOpen, expiresAtMs }: IProps) => {
  const handleOk = () => {
    setIsModalOpen(false)
  }
  const handleCancel = () => {
    setIsModalOpen(false)
  }

  return (
    <>
      <Modal
        title={<></>}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={<></>}
        className="p-0 custom-modal rouder-31"
      >
        <div className="relative ">
          <span className="absolute right-2 top-2">
            <IconCancel
              handleCancel={() => {
                handleCancel()
              }}
            />
          </span>
          <img src={`${img}&bg=5`} alt="" className="mx-auto w-full" />
          <DownloadQrImage imageSrc={img ? `${img}&bg=5` : undefined} fileName="acb-qr-thanh-toan.png" />
          <QrExpiryNotice
            isModalOpen={isModalOpen && !!img}
            paymentChannel="ACB"
            resetKey={img}
            expiresAtMs={expiresAtMs}
          />
        </div>
      </Modal>
    </>
  )
}
export default ModalACB
